import { UPDATE_LOGIN_RESULT } from './login.constants'
import { handleToken } from './login.helper'

export const updateLoginResult = (dispatch: any) => (
  accessToken: any,
  idToken: any,
  refreshToken: any,
  email: any,
) => {
  handleToken(accessToken, idToken, refreshToken, email)
  dispatch({
    type: UPDATE_LOGIN_RESULT,
    payload: { accessToken, idToken, refreshToken, email },
  })
}
